import { ChainConfigMap } from '@/const/chains';
import { SupportedChainId } from '@packet/constants/AppSupportChains';
import { http, sleep } from '@packet/management';
import { Hash } from 'viem';

export const freezeCommitment = async (chainId: SupportedChainId, commitment: string) => {
  console.log('ChainConfigMap', ChainConfigMap);

  return http().post<Hash>(`${ChainConfigMap[chainId].freezeApiUrl}/api/v1/freeze`, { commitment });
};

/**
 * 等待 API 交易完成
 * @param apk 用户应用密钥
 * @param txhash 提交的交易哈希
 * @returns API 响应结果
 */
export const waitForFreezeApiTransaction = async (chainId: SupportedChainId, txhash: Hash): Promise<Hash> => {
  let attempts = 0;
  const maxAttempts = 60; // 最大尝试次数
  const pollInterval = 2000; // 轮询间隔 2 秒

  while (attempts < maxAttempts) {
    try {
      const response = await http().get<Hash>(`${ChainConfigMap[chainId].relayerApiUrl}/api/v1/txhash`, { txhash });
      if (!response.code && response.data) {
        return response.data;
      }

      // 如果返回错误但可能是临时状态，继续等待
      attempts++;
      if (attempts < maxAttempts) {
        await sleep(pollInterval);
      }
    } catch (error) {
      attempts++;
      if (attempts >= maxAttempts) {
        throw error;
      }
      await sleep(pollInterval);
    }
  }

  throw new Error('Transaction wait timeout');
};
